import { Flag } from "web-ui";
import type { SVGProps } from "web-ui/dist/types/components/SVGSprite";

import chessFlag from "../images/chess.svg";
import mathFlag from "../images/math.svg";
import musicFlag from "../images/music.svg";
import type { LanguageId } from "../util/languages";

export interface Props extends SVGProps {
  lang: LanguageId;
  /**
   * Sets the width of the flag to the specified number,
   * and the height accordingly. This can be used instead
   * of CSS to ensure the ratio remains correct.
   */
  size?: number;
}

export const MegaFlag = ({ lang, size, style, ...rest }: Props) => {
  if (lang === "mega") {
    return (
      <span>
        <img alt="math flag" className={rest.className} src={mathFlag} />{" "}
        <img alt="music flag" className={rest.className} src={musicFlag} />{" "}
        <img alt="chess flag" className={rest.className} src={chessFlag} />
      </span>
    );
  } else if (lang === "math") {
    return <img alt="math flag" className={rest.className} src={mathFlag} />;
  } else if (lang === "music") {
    return <img alt="music flag" className={rest.className} src={musicFlag} />;
  } else if (lang === "chess") {
    return <img alt="chess flag" className={rest.className} src={chessFlag} />;
  } else if (lang === "all" || lang === "langs") {
    // "all" is not a valid language code for Flag component, use "un" (unknown/universal) instead
    // "all" is only used for external challenges, and there is no user facing portal, so
    // this flag should never be seen.
    return <Flag lang="un" size={size} style={style} {...rest} />;
  } else if (lang === "zh-WU") {
    // web-ui's flag sprite has no Shanghainese entry; the apps use the Chinese flag for it.
    return <Flag lang="zh" size={size} style={style} {...rest} />;
  } else if (lang === "kn" || lang === "mr" || lang === "ur") {
    // web-ui has no flags for these; they are only base languages of English courses.
    return <Flag lang="un" size={size} style={style} {...rest} />;
  } else {
    return <Flag lang={lang} size={size} style={style} {...rest} />;
  }
};
